import React, { createContext, useContext } from 'react'
import { useNotification, NotificationOptions } from '../../hooks/useNotification'
import ToastNotification from './ToastNotification'

interface NotificationContextType {
  showNotification: (options: NotificationOptions) => string
  hideNotification: (id: string) => void
  hideAllNotifications: () => void
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined)

export const useNotificationContext = () => {
  const context = useContext(NotificationContext)
  if (!context) {
    throw new Error('useNotificationContext must be used within a NotificationProvider')
  }
  return context
}

interface Props {
  children: React.ReactNode
}

export const NotificationProvider: React.FC<Props> = ({ children }) => {
  const { notifications, showNotification, hideNotification, hideAllNotifications } = useNotification()

  return (
    <NotificationContext.Provider 
      value={{ showNotification, hideNotification, hideAllNotifications }}
    >
      {children}
      
      {/* Render notifications */}
      <div data-testid="notification-container">
        {notifications.map((notification, index) => (
          <div
            key={notification.id}
            style={{
              position: 'fixed',
              top: `${20 + (index * 120)}px`,
              right: '20px',
              zIndex: 9999
            }}
          >
            <ToastNotification
              notification={notification}
              onDismiss={hideNotification}
            />
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  )
} 